import React, { Component } from 'react'

export default class Ci extends Component {
    render() {
        return (
            <main className="page-main-pal container">
                <div className="alocolumns clearfix">
                    <div className="column main">
                    <div className="product-view">
                        <div className="product-essential">
                        <div className="row">
                            <div className="product media product-img-box clearfix col-md-5 col-sm-5 col-xs-12">
                            <div className="gallery-placeholder _block-content-loading" data-gallery-role="gallery-placeholder">
                                <img alt="main product" className="gallery-placeholder__image" src="https://zollwebstore.com/media//myDevices/images/AEDPlus_1.jpg" />
                            </div>
                            </div>
                            <div className="product-info-main product-shop col-md-7 col-sm-7 col-xs-12">
                            <div className="product-info-price">
                                <div className="page-title-wrapper">
                                    {/* ganti judul product detail */}
                                <h1 className="page-title">
                                    <span className="base" data-ui-id="page-title-wrapper">ZOLL AED Plus</span>
                                </h1>
                                </div>
                                <span data-role="amhideprice-hide-button" id="amhideprice-product-id-314-1040" style={{display: 'none !important'}} />
                            </div>
                            <div className="product attribute overview">
                                {/* ganti product description product detail */}
                                <div className="value" itemProp="description">
                                    <p>ZOLL AED Plus for public rescuers</p>
                                    <p>
                                    Zoll AED Plus adalah pilihan terbaik bagi mereka yang mencari defibrillator berkualitas tinggi dengan fitur canggih untuk mendukung penyelamatan nyawa. Dirancang dengan teknologi mutakhir, AED ini menawarkan berbagai keunggulan yang membuatnya menonjol di pasaran.
                                    </p>
                                    <h2> <strong>Fitur ZOLL AED Plus</strong></h2>
                                    <ul>
                                        <li>
                                            Teknologi Real CPR Help®
                                        </li>
                                        <li>
                                            Tahan Debu dan Kelembaban
                                        </li>
                                        <li>
                                            Gambar Langkah-langkah Panduan
                                        </li>
                                        <li>
                                            Elektroda Pads Terhubung
                                        </li>
                                        <li>
                                            Pengujian Otomatis
                                        </li>
                                        <li>
                                            Daya Tahan Baterai Yang Lama
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>    
                    </div>
                </div>
            </main>
        )
    }
}
